// extracted by mini-css-extract-plugin
export default {"layout":"AdminLayout_layout__9ZEb6","content":"AdminLayout_content__mbte0"};